import * as React from 'react';
import { cn } from '@/lib/utils';

// Main container
const MastHead = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <section
      ref={ref}
      className={cn(
        `relative mb-16 flex h-[340px] w-full items-center overflow-hidden rounded-none border-none bg-cover bg-right
        bg-no-repeat shadow-none lg:h-[540px]`,
        className,
      )}
      {...props}
    />
  ),
);
MastHead.displayName = 'MastHead';

const MastHeadBackground = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        `pointer-events-none absolute inset-0
        bg-[linear-gradient(to_right,rgba(13,13,13,0.65)_0%,rgba(13,13,13,0.32)_40%,rgba(0,0,0,0)_100%)]`,
        className,
      )}
      {...props}
    />
  ),
);
MastHeadBackground.displayName = 'MastHeadBackground';

const MastHeadContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('relative z-10', className)} {...props} />,
);
MastHeadContent.displayName = 'MastHeadContent';

const MastHeadTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h1
      ref={ref}
      className={cn(
        'mb-2 text-[2.25rem] font-bold leading-none text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.60)] lg:text-[54px]',
        className,
      )}
      {...props}
    />
  ),
);
MastHeadTitle.displayName = 'MastHeadTitle';

const MastHeadSubtitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h2
      ref={ref}
      className={cn(
        'mb-2 text-lg font-bold leading-[28px] text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.60)] lg:text-[20px]',
        className,
      )}
      {...props}
    />
  ),
);
MastHeadSubtitle.displayName = 'MastHeadSubtitle';

const MastHeadDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={cn(
        'mb-6 max-w-2xl text-b1 font-normal text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.60)]',
        className,
      )}
      {...props}
    />
  ),
);
MastHeadDescription.displayName = 'MastHeadDescription';

const MastHeadActions = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('flex gap-4', className)} {...props} />,
);
MastHeadActions.displayName = 'MastHeadActions';

export {
  MastHead,
  MastHeadBackground,
  MastHeadContent,
  MastHeadTitle,
  MastHeadSubtitle,
  MastHeadDescription,
  MastHeadActions,
};
